import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchNycbsPharmaOrdersFromApi } from "../../redux/slice/nycbsPharmaExternal/nycbsPharmaOrder";
import { AppDispatch } from "../../redux/store/store";
import NycbsPharmaTable from "./nycbsPharmaTable/nycbsPharmaTable";

const NycbsLayout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const initialLimit = 40;

  useEffect(() => {
    dispatch(fetchNycbsPharmaOrdersFromApi(initialLimit));
  }, []);

  return (
    <div className="nycbs_order__layout h-full w-full rounded-lg bg-primaryGray-16 px-4 pb-4">
      <div className="nycbs_order__inner-container flex h-full flex-col gap-2 rounded bg-white p-4">
        <div className="nycbs_order__heading text-h11 font-bold">PA Orders</div>
        <div className="nycbs_order__table-container flex-1 overflow-auto">
          <NycbsPharmaTable />
        </div>
      </div>
    </div>
  );
};

export default NycbsLayout;
